import { PageTransition } from '@/constant/transition'
import { fetchProgramTypes, type ProgramType } from '@/util/ref'
import { useQuery } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Stack from 'react-bootstrap/Stack'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { fetchEducationHistory, selectedProgramType } from './data'
import { container } from './style.css'
import { DEFAULT_EDU_INFO } from '../EducationInfo/data'
import { useEffect } from 'react'
import { queryClient } from '@/util/queryClient'

export default function ProgramTypeSelector() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    data: programTypes,
    isLoading,
    isError,
  } = useQuery<ProgramType[]>({
    queryKey: ['program-type'],
    queryFn: fetchProgramTypes,
    staleTime: 1000 * 60 * 5,
  })
  const { data: edus } = useQuery({
    queryKey: ['education-history'],
    queryFn: fetchEducationHistory,
    staleTime: 1000 * 60 * 60,
  })
  const [programType, setProgramType] = useAtom(selectedProgramType)
  // const [_, setEduInfoData] = useAtom(eduInfoAtom)

  useEffect(() => {
    if (edus && edus.length) {
      const { programType } = edus[0]
      setProgramType({ programType })
    }
  }, [edus, setProgramType])

  return (
    <div className={container}>
      <FloatingLabel controlId="program-type-selector" label="学科種別" className="mb-3">
        <Form.Select
          value={programType.programType}
          onChange={(e) =>
            setProgramType((prev) => {
              const newValue = e.target.value
              if (prev.programType === newValue) return prev
              // setEduInfoData(DEFAULT_EDU_INFO)
              queryClient.setQueryData(
                ['education-history'],
                [{ ...DEFAULT_EDU_INFO, programType: newValue }]
              )
              return { programType: newValue }
            })
          }
          aria-label="Floating label program type selector"
        >
          <option value="" disabled hidden>
            学科種別を選択してください
          </option>
          {isError ? (
            <option>error</option>
          ) : isLoading || !programTypes ? (
            <option>Loading...</option>
          ) : (
            programTypes.map((pt) => (
              <option key={pt.id} value={pt.id}>
                {t(`programType.${pt.id}`)}
              </option>
            ))
          )}
        </Form.Select>
      </FloatingLabel>
      <Stack direction="horizontal">
        <Button
          variant="outline-secondary"
          size="lg"
          onClick={() => {
            navigate('/onboarding/user-addr', {
              state: { direction: PageTransition.FromLeft },
            })
          }}
        >
          ←
        </Button>
        <Button
          variant="outline-primary"
          size="lg"
          className="ms-auto"
          disabled={!programType}
          onClick={() => {
            navigate('/onboarding/edu-info', {
              state: { direction: PageTransition.FromRight },
            })
          }}
        >
          →
        </Button>
      </Stack>
    </div>
  )
}
